import React, { useEffect, useState } from "react";
import "../Login/Login.scss";
import { Link, useNavigate } from "react-router-dom";
import bgBanner from "../../assets/images/bg-img.svg";
import LogoIcon from "../../assets/images/white_locshark_1.png";
import { Formik } from "formik";
import * as Yup from "yup";
import { jwtDecode } from "jwt-decode";
import useApi from "../../hook/useAPI";
import { AUTH, DEVICE } from "../../utils/const";
import { toast } from "react-toastify";

const Login = () => {
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const rememberData = localStorage.getItem("userRememberData")? JSON.parse(localStorage.getItem("userRememberData")): null;
  const [rememberMe, setRememberMe] = useState(rememberData?.rememberMe ?? false);
  const navigate = useNavigate();
  const token = localStorage.getItem('token')
  const role = localStorage.getItem('UserRole')
  // const Client_token = {
  //   username: String("armani@locshark.com"),
  //   password:String("@Armani11"),
  //   grant_type:String("password")
  // };

  const handleForgotPasswordClick = () => {
    navigate("/forgot-password");
  };
  const { postData, getData, gpsiottoken } = useApi();

  useEffect(()=>{
        if(token){
          navigate(role === "1" ? "/main/user" : "/main/home");
        }
      },[role])

  const handleLoginClick = async (values) => {
    try {
      const response = await postData(`${AUTH.POST_LOGIN}`, {
        email: values?.email,
        password: values?.password,
      });
      if (response.status || response.status === 200) {
        // const res = await getData(`${AUTH?.ONCE_AUTHENTICATE}`);
        localStorage.setItem("1nce_expires_in" , 6000000000)
        localStorage.setItem('1nce_access_token', 'temp_token');
        
        const decoded = jwtDecode(response?.token);
        localStorage.setItem('token', response?.token);
        const role = decoded?.role === 'admin';
        localStorage.setItem('UserRole', role ? 1 : 2);
        localStorage.setItem('isLogin', true);
        localStorage.setItem('fc_cc', true);
        localStorage.setItem(
          "userRememberData",
          rememberMe ? JSON.stringify({ ...values, rememberMe: true }) : ""
        );
        toast.success("Login successfully");
        // const response_tkn = await gpsiottoken(DEVICE.TOKEN_DEVICE, Client_token);
        // localStorage.setItem('TokenDevice', response_tkn?.access_token);
         navigate(role ? "/main/user" : "/main/home");
    //       const target = role === "1" ? "/main/user" : "/main/home";
    // window.location.href = target;

      }
    } catch (err) {
      setError(err?.response?.data?.message);
    }
  };


  const initialValues = {
    email: rememberData?.rememberMe === true ? rememberData?.email : "",
    password: rememberData?.rememberMe === true ? rememberData?.password : "",
  };

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(emailRegex, "Invalid email format")
      .required("Email is required"),
    password: Yup.string()
      .required("Password is required"),
  });

  return (
    <div className="login-section login-wrap">
      <div className="container m-0">
        <div className="row m-0 flex-wrap-reverse">
          <div className="col-md-5 p-0">
            <div className="sign-bg-banner ">
              <img src={bgBanner} className="img-fluid " alt="loginBanner" />

              <div className="over-sml-img">
                <img src={LogoIcon} className="img-fluid " alt="loginLogo" />
              </div>
            </div>
          </div>
          <div className="col-md-7">
            <div className="login-form-wrapper">
              <div className="form-wrapper-block text-center w-100">
                <h4 className="login-form-wrapper-title">Sign in</h4>
                <p className="login-form-wrapper-subtitle">
                  Enter your email and password to Sign In
                </p>
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleLoginClick}
                >
                  {({
                    values,
                    touched,
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                  }) => (
                    <>
                      <form onSubmit={handleSubmit} noValidate>
                        <div className="form_field_wrapper">
                          <input
                            value={values.email}
                            type="text"
                            name="email"
                            className="form-control"
                            placeholder="Email"
                            onChange={(e) => {
                              setError("");
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                          />
                          {errors.email && touched?.email && (
                            <div className="error-message" id="feedback">
                              {errors.email}
                            </div>
                          )}
                        </div>
                        <div className="form_field_wrapper">
                          <input
                            value={values.password}
                            type={showPassword ? "text" : "password"}
                            name="password"
                            className="form-control"
                            placeholder="Current password"
                            onChange={(e) => {
                              setError("");
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                          />
                          <span
                            className="password-toggle"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? (
                              <i className="bi bi-eye" />
                            ) : (
                              <i className="bi bi-eye-slash" />
                            )}
                          </span>
                          {errors.password && touched?.password && (
                            <div className="error-message" id="feedback">
                              {errors.password}
                            </div>
                          )}
                        </div>
                        <div className="form_field_wrapper">
                          <div className="error-message" id="feedback">
                            {error}
                          </div>
                        </div>
                        <div className="forgot-sec">
                          <div className="togal-switch">
                            <div className="custome-switch">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  onChange={(e) =>
                                    setRememberMe(e.target.checked)
                                  }
                                  checked={rememberMe}
                                />
                                <span className="slider round"></span>
                              </label>
                            </div>
                            <p>Remember me</p>
                          </div>
                          <div>
                            <button
                              type="button"
                              onClick={handleForgotPasswordClick}
                            >
                              Forgot Password?
                            </button>
                          </div>
                        </div>
                        <div className="sign-in-btn">
                          <button type="submit" className="btn btn-primary">
                            SIGN IN
                          </button>
                        </div>
                      </form>
                    </>
                  )}
                </Formik>
                <div className="sign-up-btn">
                  <p>
                    Don't have an account?{" "}
                    <Link
                      className="sign-up-link"
                      sx={{ textTransform: "lowercase", minWidth: "auto" }}
                      to={'/signup'}
                    >
                      Sign Up
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
